module.exports = __webpack_public_path__ + "img/bg_xanh.e8382999.png";